var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link btn-sm order-1 order-lg-0 text-light",attrs:{"id":"sidebarToggle","href":"#"}},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }